module.exports = __webpack_public_path__ + "static/media/ai-icon.ae3e77b6.svg";